import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import NdsThemeProvider from '@ntuctech/devex-tangram/Theme/NdsThemeProvider';
import { SvgArrowDown } from '@ntuctech/devex-tangram/Icon';
import { Typography } from '@ntuctech/devex-tangram';
import Loader from '../Theme/Loader';
import { useFeatureFlag } from '../FeatureFlagProvider';

const DropDownContainer = styled('div')`
  cursor: pointer;
  height: 3rem;
  max-width: 30rem;
  border: 1px solid #666666;
  box-sizing: border-box;
  border-radius: 4px;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #333333;
  width: 100%;
  position: relative;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
  margin-top: 1.5rem;
  .display-value {
    top: 0.75rem;
    left: 0.75rem;
    position: absolute;
  }
`;

const DropDownHeader = styled('div')`
  padding: 0.3em;
  background: #ffffff;
  margin-top: 1px;
  width: 100%;
  svg {
    position: absolute;
    right: 0;
    right: 0.75rem;
    top: 0.75rem;
  }
`;

const DropDownListContainer = styled('div')`
  z-index: 100;
  max-width: 30rem;
  width: 100%;
  left: 0;
  ${(p) => p.overlay && 'position: absolute'};
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
`;

const DropDownList = styled('ul')`
  padding: 0;
  margin: 0;
  background: #ffffff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  box-sizing: border-box;
  overflow-y: scroll;
`;

const ListItem = styled('li')`
  list-style: none;
  cursor: default;
  padding: 5px 10px 5px 10px;
  &:hover {
    background: #f2f2f2;
    color: #333333;
  }
  background: ${(props) => (props.selected ? '#E8F0FD' : '#FFF')};
`;

const DropDown = ({ options, onClick, value, overlay }) => {
  const { isReady } = useFeatureFlag();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value);
  const dropdownRef = useRef(null);

  const closeOpenMenus = (e) => {
    if (isOpen && !dropdownRef.current?.contains(e.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (value) {
      setSelectedOption(value);
    }

    document.addEventListener('mousedown', closeOpenMenus);
    return () => document.removeEventListener('mousedown', closeOpenMenus);
  }, [value, isOpen]);
  const onOptionClicked = (option) => {
    onClick(option.catergory);
    setSelectedOption(option.catergory);
    setIsOpen(false);
  };

  const displayValue = () => {
    const display = options.find((o) => {
      return o.catergory === selectedOption;
    });
    return display?.title;
  };

  if (!isReady) {
    return <Loader />;
  }
  return (
    <NdsThemeProvider>
      <div ref={dropdownRef}>
        <DropDownContainer
          data-testid="DropDown"
          tabIndex={0}
          onClick={() => {
            setIsOpen((prevState) => !prevState);
          }}
        >
          <DropDownHeader data-testid="dropdown-header">
            <Typography className="display-value" variant="bodyM">
              {displayValue()}
            </Typography>
            <SvgArrowDown size="m" color="#333333" />
          </DropDownHeader>
        </DropDownContainer>
        {isOpen && (
          <DropDownListContainer overlay={overlay}>
            <DropDownList>
              {options.map((option) => (
                <ListItem
                  data-testid={`DropDownListItem-${option.title}`}
                  onClick={() => {
                    onOptionClicked(option);
                  }}
                  key={option}
                  selected={option.value === selectedOption || false}
                >
                  {option.title}
                </ListItem>
              ))}
            </DropDownList>
          </DropDownListContainer>
        )}
      </div>
    </NdsThemeProvider>
  );
};
export default DropDown;
